module.exports = __webpack_public_path__ + "0dd237ad39684640e99406c2c936faf0.pdf";